function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function clearCheckedInputs(form, callback) {
  const inputs = Array.from(form.querySelectorAll('input'));

  function clearChecked() {
    inputs.forEach(input => {
      if (input.checked) {
        input.checked = false;
      }
    });

    const stillChecked = inputs.some(input => input.checked);

    if (stillChecked) {
      clearChecked();
    } else {
      callback();
    }
  }

  clearChecked();
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.category_1 = document.querySelector('[filtertype="parent_category"]');
    this.category_2 = document.querySelector('[filtertype="category"]');
    this.category_3 = document.querySelector('[filtertype="subcategory"]');

    this.updateCategoryActiveStates();
    FacetFiltersForm.levelThreeItemsVisibilyte();

    const facetForm = document.querySelector('.facets form');
    facetForm.addEventListener('input', this.facetsControl.bind(this));

    FacetFiltersForm.hideFilterGroup();

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.addProductFilterListeners(); 
  }

  facetsControl(event) {
    
    document.addEventListener('change', (eve) => {
      if (eve.target.hasAttribute('noneus')) {
        const input = eve.target;
        if (input) {
          clearCheckedInputs(this.querySelector('form'), () => {
            input.checked = true;
            this.updateCategoryActiveStates();
          });
        } 
      } 
    });

    const secondsFields = this.category_2.querySelectorAll('input');
    const thirdFields = this.category_3?.querySelectorAll('input');
    secondsFields.forEach(input => {
      input.addEventListener('change', (event) => {
        if (!input.checked) {
          let inpSigna = input.getAttribute('inputsigna');
          if ( thirdFields ) {
            thirdFields.forEach(input => {
              if (input.getAttribute('inputsigna') == inpSigna) {
                input.checked = false;
              }
            });
          }
        }
      });
    });

    this.updateCategoryActiveStates();

    this.debouncedOnSubmit(event);
  }

  static levelThreeItemsVisibilyte() {
    const checkedInputsCategory2 = Array.from(document.querySelectorAll('[filtertype="category"] input:checked'));

    if ( checkedInputsCategory2 ) {
     const belongingValues = checkedInputsCategory2.map(input => {
       const parentLi = input.closest('li');
       return parentLi ? parentLi.getAttribute('belonging')?.trim().toLowerCase() : null;
     }).filter(value => value !== null);

     const category3Items = document.querySelectorAll('[filtertype="subcategory"] li');
     if (category3Items) {
       category3Items.forEach(li => {
         const liBelonging = li.getAttribute('belonging')?.trim().toLowerCase();
         if (liBelonging && belongingValues.includes(liBelonging)) {
           li.classList.add('active');
         } else {
           li.classList.remove('active');
         }
       });
     }
   }
  }

  updateCategoryActiveStates() {
    const category1Inputs = this.category_1?.querySelectorAll('input');
    if (!category1Inputs) return;
    
    const hasCheckedInput1 = Array.from(category1Inputs).some(input => input.checked);
  
    if (this.category_2) {
      this.category_2.classList.toggle('active', hasCheckedInput1);
      const hasCheckedInput2 = Array.from(this.category_2.querySelectorAll('input')).some(input => input.checked);
  
      if (this.category_3) {
        this.category_3.classList.toggle('active', hasCheckedInput2);
      }
  
      const checkedInput = Array.from(category1Inputs).find(input => input.checked);
      if (checkedInput) {
        const checkedInputTitle = checkedInput.getAttribute('dataname');
        if (checkedInputTitle) {
          const facetsSummarySpan = this.category_2.querySelector('.facets__summary span');
          if (facetsSummarySpan) {
            facetsSummarySpan.innerHTML = checkedInputTitle;
          }
          document.documentElement.style.setProperty('--active', `'${checkedInputTitle}'`);
        }
      }
    }
  }

  static hideFilterGroup() {
    const groups = document.querySelectorAll('facet-filters-form details:not(.price-range)');
    const activeFiltersCount = document.querySelector('.active-facets__header .active-count');
    const diactivateFilters = document.querySelector('.clear-all');
    const activeFilters = document.querySelector('facet-filters-form').querySelectorAll('input:not(.field__input):checked').length;
    activeFiltersCount.innerHTML = activeFilters;
    if (activeFilters > 0) {
      diactivateFilters.classList.remove('hidden');
    }

    groups.forEach(item => {
      const allHidden = Array.from(item.querySelectorAll('li label'))
        .every(label => label.classList.contains('facet-checkbox--disabled'));
      item.classList.toggle('hidden', allHidden);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.hideFilterGroup();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.hideFilterGroup();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const ajaxinateLoopElement = document.getElementById('AjaxinateLoop');
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsedHTML.getElementById('AjaxinateLoop');

    if ( parsedHTML.querySelector("#ProductCount") ) {
      const countElement = document.querySelector("#ProductCount");
      const countData = parsedHTML.querySelector("#ProductCount").innerHTML;
      countElement.innerHTML = countData;
    } else if ( parsedHTML.querySelector(".search-count") ) {
      const countElement = document.querySelector(".search-count");
      const countData = parsedHTML.querySelector(".search-count").innerHTML;
      countElement.innerHTML = countData;
    }

    const paginationElement = document.querySelector(".l-collection-page__footer");
    const paginationData = parsedHTML.querySelector(".l-collection-page__footer").innerHTML.trim();
    
    if (paginationData == "") {
      paginationElement.classList.add("hidden");
    } else {
      paginationElement.classList.remove("hidden");
      paginationElement.innerHTML = paginationData;
    }
    
    if (ajaxinateLoopElement && newContent) {
      ajaxinateLoopElement.innerHTML = newContent.innerHTML;
    }
    FacetFiltersForm.levelThreeItemsVisibilyte();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('AjaxinateLoop').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
            let hasSort = window.location.href.includes('sort_by');
            if( hasSort ) {
              const urlParams = new URLSearchParams(window.location.search);
              const sort = urlParams.get('sort_by')
              forms.push(`sort_by=${sort}`);
            }
            
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  addProductFilterListeners() {
    const productFilterItems = document.querySelectorAll('.c-product-filter__item');
    productFilterItems.forEach((item) => {
      item.addEventListener('click', this.onProductFilterClick.bind(this));
    });
  }

  onProductFilterClick(event) {
    const tag = event.currentTarget.getAttribute('data-tag');
    if (!tag) return;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('sort_by', tag);

    FacetFiltersForm.renderPage(urlParams.toString(), event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    const resetCat = new FacetFiltersForm();
    resetCat.updateCategoryActiveStates();
  }
}

customElements.define('facet-remove', FacetRemove);
